import React from 'react';
import { whyChooseUsData } from '../../data/mock';

const WhyChooseUs = () => {
  return (
    <section id="why" className="py-20 lg:py-32 bg-gray-900 text-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#63E61E] rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#63E61E] rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header y Contenido */}
        <div className="text-center max-w-5xl mx-auto">
          <div className="inline-block px-4 py-2 bg-[#63E61E]/20 rounded-full mb-6">
            <span className="text-[#63E61E] font-bold text-sm tracking-wide">VENTAJAS COMPETITIVAS</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black mb-12">
            {whyChooseUsData.title}
          </h2>
          
          {/* Texto Principal */}
          <div className="text-lg lg:text-xl text-gray-300 leading-relaxed space-y-6">
            {whyChooseUsData.description.split('\n\n').map((paragraph, index) => {
              // Si el párrafo es una cita (empieza con comillas)
              if (paragraph.startsWith('"')) {
                return (
                  <p key={index} className="italic text-[#63E61E] text-2xl lg:text-3xl font-semibold mt-8">
                    {paragraph}
                  </p>
                );
              }
              // Si el párrafo contiene "tú marcas el camino"
              if (paragraph.includes('tú marcas el camino')) {
                const lines = paragraph.split('\n');
                return (
                  <div key={index} className="mt-8 space-y-2">
                    {lines.map((line, lineIndex) => (
                      <p key={lineIndex} className="text-xl lg:text-2xl font-bold text-[#63E61E]">
                        {line}
                      </p>
                    ))}
                  </div>
                );
              }
              // Párrafos normales
              return (
                <p key={index} className="text-left max-w-4xl mx-auto">
                  {paragraph}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;